export default __webpack_public_path__ + "static/media/instagram.f33e7dae.svg";